import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    table: {
      borderRadius: 4.8,
      border: `0.4rem solid ${palette.lightgrey}`,
      boxSizing: 'border-box',
      boxShadow: '0px 0px 3px 1px rgb(0 0 0 / 20%)',
      marginBottom: 40,
      overflowX: 'auto',
      maxHeight: 250,
    },
    tableTitle: {
      fontSize: 12,
      paddingBottom: 5,
      fontWeight: 500,
      marginLeft: 8,
      paddingTop: 4,
    },
    titleBackground: {
      backgroundColor: palette.lightGray,
    },
    text: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',

      '& .MuiTypography-root': {
        fontSize: 12,
        color: palette.darkGray,
      },
    },
    notFoundText: {
      fontSize: 12,
    },
    tableRow: {
      height: 20,

      '& td.MuiTableCell-root': {
        padding: '0px 16px',
        lineHeight: 1,
      },
      '&:hover': {
        background: `${palette.superLightDeepBlue} !important`,
      },
    },
    envToAnalyze: {
      backgroundColor: palette.lightRed,
    },
    status: {
      color: palette.darkGray,
    },
    analyzeStatus: {
      color: palette.darkRed,
    },
    accessButton: {
      padding: 0,
      '& .MuiSvgIcon-root': {
        fontSize: 15,
        color: palette.blue,
      },
    },
  });
